import React, { Component } from "react";
import queryString from 'query-string'
import "./Menu.scss";
import { push } from "../Services/Analytics";
import { shareFacebook, shareTwitter, shareWhatsapp, openNegishut } from "../Services/Sharing"
import { scrollDown } from "../Services/ScrollAnimation";

const sections = ["promo", "robot", "music", "photo", "view", "playbuzz"];

class Menu extends Component {
  constructor() {
    super()
    this.menuClick = this.menuClick.bind(this);
    this.state = {
      isBusy: false,
      currentHash: "promo"
    }
  }
  componentDidMount() {
    const parse = window.location.search ? queryString.parse(window.location.search) : "";

    // var _hash = window.location.hash.replace("#", "");
    // try {
    //   this.activeNavigation(_hash == "" ? sections[0] : this[_hash].classList[1])
    // } catch (e) { }
    // if (_hash && _hash != this.state.currentHash) {
    //   window.setTimeout(() => this[_hash].click(), 250);
    // }

    try {
      this.activeNavigation(!parse.s || !parse ? sections[0] : (!this[parse.s] ? sections[0] : this[parse.s].classList[1]));
    } catch (e) { }
    if (parse && parse.s != this.state.currentHash && this[parse.s]) {
      // window.setTimeout(() => this[parse.s].click(), 500);
      window.setTimeout(() => {
        var _className = this[parse.s].className.split(" ");
        // scrollDown(`section-${_className[1]}`, 0);
        this.props.setTransform(window.document.querySelector(`.section-${_className[1]}`).offsetTop / window.document.body.clientHeight);
      }, 500);
    }
  }
  componentWillReceiveProps(nextProps) {
    this.activeNavigation(sections[nextProps.currentScreen])
  }
  menuClick(event) {
    if (this.state.isBusy) return;
    var target = target ? target : event.target, _className;

    try {
      this.setState({
        isBusy: true
      }, () => {
        window.setTimeout(() => {
          this.setState({
            isBusy: false
          })
        }, 500)
      })

      _className = target.className.split(" ");
      this.activeNavigation(_className[1]);
      push("Side_bar_navigation", _className[1]);
      // scrollDown(`section-${_className[1]}`, 0)
      this.props.setTransform(window.document.querySelector(`.section-${_className[1]}`).offsetTop / window.document.body.clientHeight);
      this.props.toggleMenu(true);

    } catch (error) { }
  }
  clearActivs() {
    for (var j = 0, i = 0; i < this.container.childElementCount; i++) {
      if (this.container.children[i].className.indexOf("circle") == -1) continue;

      this.container.children[i].className = this.container.children[i].className.replace(" active", "");
    }
  }
  activeNavigation(_className) {
    if (!this[_className]) return;
    this.clearActivs();
    this[_className].className = this[_className].className += " active";
    // if (typeof (window.history.pushState) == 'function') {
    //   window.history.pushState(null, "/", `#${_className}`);
    // } else {
    //   window.location.hash = '#' + _className;
    // }
    if (typeof (window.history.pushState) == 'function') {
      var parse = window.location.search ? queryString.parse(window.location.search) : "";
      parse = {
        ...parse,
        s: _className
      }
      window.history.pushState(null, `/`, `?${queryString.stringify(parse)}#`);
    }
  }
  render() {
    return (
      <menu id="navmenu" className={this.props.menuClicked ? "active" : ""}>
        <div className="padding">
          <div className="container" onMouseOver={() => this.props.toggleMenu(true)} onClick={this.menuClick} ref={container => this.container = container}>
            <div className="line"></div>
            <div className={`circle promo`} ref={promo => this.promo = promo}></div>
            <div className="line"></div>
            <div className={`circle robot`} ref={robot => this.robot = robot}></div>
            <div className="line"></div>
            <div className={`circle music`} ref={music => this.music = music}></div>
            <div className="line"></div>
            <div className={`circle photo`} ref={photo => this.photo = photo}></div>
            <div className="line"></div>
            <div className={`circle view`} ref={view => this.view = view}></div>
            <div className="line"></div>
            <div className={`circle playbuzz`} ref={playbuzz => this.playbuzz = playbuzz}></div>
            <div className="line"></div>
          </div>
          <div className="share">
            <div className="share-container">
              <div className="text">
                שתפו
              </div>
              <div onClick={shareFacebook} className="facebook"></div>
              <div onClick={shareTwitter} className="twitter"></div>
              <div onClick={shareWhatsapp} className="whatsapp"></div>
              <div onClick={openNegishut} className="negishut"></div>
            </div>
          </div>
        </div>
      </menu>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.jsx